import React, { useReducer } from 'react';

// GLOBAL VARIABLES
import { RETAIL_WHOLESALE, WHOLESALE_FORMAT } from 'codes';

// HELPERS
import useRecordView from 'helpers/getRecordView';

// LOCAL COMPONENTS
import AfterMarketFinance from '../parts/AfterMarketFinance';
import CustomerInfo from '../parts/CustomerInfo';
import EmployeeInfo from '../parts/EmployeeInfo';
import DealCompletion from '../parts/DealCompletion';
import DealerIncentive from '../parts/DealerIncentive';
import DealerPack from '../parts/DealerPack';
import DownPayment from '../parts/downPayment/DownPayment';
import InternalDealRecap from '../parts/InternalDealRecap';
import InventoryInternal from '../parts/InventoryInternal';
import PricingInfo from '../parts/PricingInfo';
import PurchaseInfo from '../parts/PurchaseInfo';
import Rebates from '../parts/Rebates';
import Trade from '../parts/Trade';
import ReviewSpotInstructions from '../parts/ReviewSpotInstructions';
import SaleAttachments from '../parts/SaleAttachments';
import SalesDetail from '../parts/Detail';
import SpotInstructions from '../parts/spotInstructions/SpotInstructions';
import VehicleCost from '../parts/VehicleCost';
import VehicleInfo from '../parts/VehicleInfo';
import VehicleRegistration from '../parts/VehicleRegistration';
import Comments from '../parts/Comments';

// REDUCER
const saleTypeReducer = (state, { name, value }) => {
  const newState = {
    ...state,
    [name]: value
  };
  newState.isWholesaleSimplified = parseInt(newState.sale_type_category_id) === RETAIL_WHOLESALE.wholesale.numeric && parseInt(newState.wholesale_format_id) === WHOLESALE_FORMAT.simplified.numeric;
  return newState;
}

// MAIN COMPONENT
const SalesEditSections = ({ status }) => {
   
  // HOOKS
  const { isAdd } = useRecordView();

  // STATE
  const [ { isWholesaleSimplified }, updateSaleType ] = useReducer(saleTypeReducer, {})

  // MEMOS
  const isDelivered = status === 'delivered';

  // RENDER
  return (
    <>
      <VehicleInfo
        updateSaleType={updateSaleType}
      />
      <PricingInfo />
      <InventoryInternal />
      {!isWholesaleSimplified ? <EmployeeInfo /> : null}
      <CustomerInfo />
      {!isWholesaleSimplified ? <VehicleRegistration /> : null}
      <PurchaseInfo />
      {!isWholesaleSimplified ? <Rebates /> : null}
      <Trade />
      <VehicleCost />
      <DealerIncentive />
      {!isAdd && isDelivered && (
        <>
          <AfterMarketFinance />
          <ReviewSpotInstructions />
          <DealCompletion />
        </>
      )}
      {!isWholesaleSimplified ? <DownPayment /> : null}
      <DealerPack />
      <InternalDealRecap />
      <SpotInstructions />
      <SaleAttachments />
      <Comments/>
    </>
  );
};

// EXPORT
export default function Edit(props) {
  return (
    <SalesDetail>
      <SalesEditSections {...props} />
    </SalesDetail>
  );
}
